import React, { Suspense, useMemo } from 'react';
import {
  BrowserRouter as Router, Routes, Route,
  Navigate,
  Outlet,
} from 'react-router-dom';
import privateViewList, { publicViewList, landingViewList } from './ViewList';
import MainPage from '../components/layout/mainPage/MainPage';
import ApiResponseHandlerReturn from '../components/notifications/Notifications';
import AccountConfiguration from '../views/private/accountConfiguration/AccountConfiguration';
import InvitePage from '../views/public/InvitePage';
import useTheme from '../theme/theme';

function LayoutWithBackground() {
  return (
    <div>
      <div style={{
        width: '100vw',
        height: '100vh',
        position: 'fixed',
        background: 'var(--mainDark)',
        zIndex: -1,
      }}
      />
      <Outlet />
      <div style={{
        position: 'fixed',
        bottom: 5,
        right: 5,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'right',
      }}
      >
        <img
          src={`${window.location.origin}/Flag_of_France.svg`}
          alt="Made in France"
          style={{ width: '30px', height: 'auto' }}
        />
      </div>
    </div>
  );
}

// 🔐 Route protégée
// eslint-disable-next-line react/prop-types
function PrivateRoute({ children }) {
  const token = localStorage.getItem('accessToken');
  const isFirstTime = localStorage.getItem('firstTime');
  if (!token) return <Navigate to="/login" />;
  if (isFirstTime) return <Navigate to="/accountConfiguration" />;
  return children;
}

// eslint-disable-next-line react/prop-types
function PrivateIntroRoute({ children }) {
  const token = localStorage.getItem('accessToken');
  const isFirstTime = localStorage.getItem('firstTime');
  if (!token) return <Navigate to="/login" />;
  if (!isFirstTime) return <Navigate to="/workspaces" />;
  return children;
}

// eslint-disable-next-line react/prop-types
function PublicRoute({ children }) {
  const token = localStorage.getItem('accessToken');
  const isFirstTime = localStorage.getItem('firstTime');
  if (token && isFirstTime) return <Navigate to="/accountConfiguration" />;
  if (token) return <Navigate to="/workspaces" />;
  return children;
}

function Main() {
  // eslint-disable-next-line no-unused-vars
  const { theme } = useTheme();
  const viewListSideBar = useMemo(
    () => privateViewList.filter(({ isNotSideBar }) => !isNotSideBar)
      .map(({ label, path, Logo }) => ({ label, path, Logo })),
    [privateViewList],
  );
  return (
    <Router basename="/">
      <Suspense fallback={<MainPage viewList={viewListSideBar} loading />}>
        <ApiResponseHandlerReturn />
        <Routes>
          {privateViewList.map(({ label, path, Component }) => (
            <Route
              key={label}
              path={path}
              element={(
                <PrivateRoute>
                  <MainPage viewList={viewListSideBar}>
                    <Component />
                  </MainPage>
                </PrivateRoute>
          )}
            />
          ))}
          <Route path="/invite/:token" element={<InvitePage />} />
          <Route element={<LayoutWithBackground />}>
            {landingViewList.map(({ label, path, Component }) => (
              <Route key={label} path={path} element={<Component />} />
            ))}
            <Route
              key="accountConfiguration"
              path="/accountConfiguration"
              element={(
                <PrivateIntroRoute>
                  <AccountConfiguration />
                </PrivateIntroRoute>
          )}
            />
            {publicViewList.map(({ label, path, Component }) => (
              <Route
                key={label}
                path={path}
                element={(
                  <PublicRoute>
                    <Component />
                  </PublicRoute>
          )}
              />
            ))}
          </Route>
          <Route path="/" element={<Navigate to="/home" replace />} />
        </Routes>
      </Suspense>
    </Router>
  );
}

export default React.memo(Main);
